import Navbar from "../components/Navbar"
import Hero from "../components/Hero"
import Demo from "../components/Demo"
import Benefits from "../components/Benefits"
import Trust from "../components/Trust"
import CallToAction from "../components/CallToAction"
import Footer from "../components/Footer"

const Home = () => {
    return (
        <div className="font-sans text-gray-900 bg-white antialiased">
            <div className="sticky top-0 z-50">
                <Navbar />  
            </div>
            <Hero />
            <Demo />
            <Benefits />
            <Trust />
            <CallToAction />
            <Footer />
        </div>
    )
}

export default Home